export default __webpack_public_path__ + "static/bookinfo-on-mesh-37ab70e6e98dfa2ff9d2a52159470dbe.webp";